const MIRROR_VALUES = {
  left: 'right',
  right: 'left',
  start: 'end',
  end: 'start',
}
const CSS_MIRROR_VALUES = [
  // 'textAlign',
  'float',
  'backgroundPosition',
]

export const transformCSSStyle = (style, textAlign = false) => {
  let ret = _.assign({}, style)

  _.each(CSS_MIRROR_VALUES, (key) => {
    let val = String(ret[key])
    if (key === 'backgroundPosition') {
      // if (val.indexOf('left') !== -1) {
      //     ret[key] = val.replace('left', 'right')
      // } else if (val.indexOf('right') !== -1) {
      //     ret[key] = val.replace('right', 'left')
      // }
    } else if (_.has(MIRROR_VALUES, val)) {
      ret[key] = MIRROR_VALUES[val]
    }
  })
  if (textAlign) {
    let val = String(ret['textAlign'])
    if (val.indexOf('left') !== -1) {
      ret['textAlign'] = val.replace('left', 'right')
    } else if (val.indexOf('right') !== -1) {
      ret['textAlign'] = val.replace('right', 'left')
    }
  }

  const mrl = ret['marginLeft']
  const mrr = ret['marginRight']
  const pl = ret['paddingLeft']
  const pr = ret['paddingRight']

  if (mrl || mrr) {
    const [left, right] = [mrr, mrl]
    ret['marginLeft'] = left
    ret['marginRight'] = right
  }
  if (pl || pr) {
    const [left, right] = [pr, pl]
    ret['paddingLeft'] = left
    ret['paddingRight'] = right
  }

  return ret
}
